// Resolves API + Cognito endpoints at runtime (window.RUNTIME_CONFIG from
// /config.js, which deploy.sh may replace), with build-time VITE_* fallbacks
// and localhost defaults: kast-common's createDeploymentConfig.
import { createDeploymentConfig, type DeploymentConfigValues } from "@jkast90/kast-common/config";

const fields = {
  // Vite proxies /play-api to the real API in dev (vite.config.ts).
  apiUrl: {
    key: "VITE_PLAY_API_BASE_URL",
    default: (c: { isLocalhost: boolean }) => (c.isLocalhost ? "/play-api" : "https://api.kast-dev.net/play-api"),
  },
  cognitoDomain: "VITE_COGNITO_DOMAIN",
  cognitoUiUrl: { key: "VITE_COGNITO_UI_URL", default: "https://login.kast-dev.net" },
  clientId: "VITE_COGNITO_CLIENT_ID",
} as const;

export const deploymentConfig = createDeploymentConfig({ env: import.meta.env, fields });

export type DeploymentConfig = DeploymentConfigValues<typeof fields>;

export const getDeploymentConfig: () => DeploymentConfig = deploymentConfig.get;
